import { 
	createSlice,
	createSelector,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'

import {
	envAwarePost,
	dateToAPIStandard
} from '../../../util/util'

export const getPurchaseFormTree = createAsyncThunk(
	'getPurchaseFormTree',
	async payload => await envAwarePost(
		'api/customForms/',
		{action:'getPurchaseFormTree',...payload}
	)
)

export const refreshPurchaseFormTree = createAsyncThunk(
	'refreshPurchaseFormTree',
	async payload => await envAwarePost(
		'api/customForms/',
		{action:'getPurchaseFormTree',...payload}
	)
)

export const createFormPurchaseItem = createAsyncThunk(
	'createFormPurchaseItem',
	async (payload) => (envAwarePost('api/customForms/api/', {action:'createFormPurchaseItem',...payload}))
)

export const removeFormPurchaseItem = createAsyncThunk(
	'removeFormPurchaseItem',
	async (payload) => (envAwarePost('api/customForms/api/', {action:'removeFormPurchaseItem',...payload}))
)



const slice = createSlice({
	name: 'purchaseForms',
	initialState : {
		tree:{},
		status:'init'
	},
	reducers : {},
	extraReducers : {
		[getPurchaseFormTree.pending] : (state,action)=>{
			state.status = 'pending'
		},
		[getPurchaseFormTree.fulfilled] : (state,action)=>{
			state.tree = action.payload.data.tree
			state.status = 'idle'
		},
		[refreshPurchaseFormTree.fulfilled] : (state,action)=>{
			state.tree = action.payload.data.tree
			state.status = 'idle'
		},
		[createFormPurchaseItem.pending] : (state,action)=>{
			const {item_type,item_id,form_id} = action.meta.arg
			//custom payments and sessions don't have furter nesting
			if(['custom_payment','session'].includes(item_type)){
				//these are neseted like tree[type] = [array of form ids]
				if(!Boolean(state.tree[item_type])){
					state.tree[item_type] = []
				}
				state.tree[item_type].push(form_id)
			}else{
				//all other payments have nesting like tree[type][id] = [array of form ids]
				if(!Boolean(state.tree[item_type])){
					state.tree[item_type] = {}
				}
				if(!Boolean(state.tree[item_type][item_id])){
					state.tree[item_type][item_id] = []
				}
				state.tree[item_type][item_id].push(form_id)
			}//end else
		},//end createFormPurchaseItem.pending
		[removeFormPurchaseItem.pending] : (state,action)=>{
			const {item_type,item_id,form_id} = action.meta.arg
			//custom payments and sessions don't have furter nesting
			if(['custom_payment','session'].includes(item_type)){
				state.tree[item_type] = state.tree[item_type].filter(id=>id!==parseInt(form_id))
			}else{
				state.tree[item_type][item_id] = state.tree[item_type][item_id].filter(id=>id!==parseInt(form_id))
			}//end else
		},//end removeFormPurchaseItem.pending
	}
})

//export const { } = slice.actions


export default slice.reducer